module.exports = __webpack_public_path__ + "9270ef6f77d9befaf061990c16a42df3.jpg";